import { clientAppLog, createCodeSourceName } from '@/app/components/search/logging/clientAppLog.ts';

const reportedKeys = new Set<string>();

export const logMissingTranslation = (key: string) => {
  if (typeof window === 'undefined' || !key || reportedKeys.has(key)) return;

  reportedKeys.add(key);
  clientAppLog({
    level: 'ERROR',
    codeSourceName: createCodeSourceName('MissingTranslation'),
    logMessage: `Missing translation. key=${key}`,
    url: window.location.href,
  });
};
